module.exports = __webpack_public_path__ + "img/empty.a33eb24e.png";